import Header from "../titulo";
import Footer from "../footer";
import { Outlet } from "react-router-dom";

export function Layout() {
    return (
        <>
            <Header />
            <Outlet />
            <Footer/>
        </>
    )
}
